module.exports = __webpack_public_path__ + "img/securityCode.2ca72f02.png";